import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend, Label
} from "reactstrap"
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import { accessRole } from '../../../../../helpers/access_role'
import Select from '../../../../../helpers/ui/CustomSelect'
import { Preview } from '../../../../../helpers/ui/FileInput'
import { AvForm, AvField } from "availity-reactstrap-validation"

import { Link, Redirect, withRouter } from "react-router-dom"

import apiResponse from '../../../../../services/apiResponse'
import { cancelToken } from '../../../../../services/adapters/kepegawaian/menuService'

import IndexBloc from '../Index/Blocs/IndexBloc'
import Shimmer from 'react-shimmer-effect'

let peg_uuid = JSON.parse(localStorage.getItem('userdata')) != null ? JSON.parse(localStorage.getItem('userdata')).employee_uuid : "";
if(accessRole('approve')){
    peg_uuid = JSON.parse(localStorage.getItem('employeeSelected')) != null ? JSON.parse(localStorage.getItem('employeeSelected')).employee_uuid : "";
}

const satuanWaktu = [
    { value: 'Hari', label: 'Hari'},
    { value: 'Minggu', label: 'Minggu'},
    { value: 'Bulan', label: 'Bulan' },
]

const reformatDate = (date, withDay = false) => {
    const months = [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember",
    ];
    const days = [
        "Minggu",
        "Senin",
        "Selasa",
        "Rabu",
        "Kamis",
        "Jum'at",
        "Sabtu"
    ]
    
    const d = new Date(date);

    let dt = d.getDate()
    if (dt < 10)
        dt = '0'+dt

    let day = ''
    if (withDay) {
        day = days[d.getDay()] + ", "
    }

    if (date) {
        return day + dt + " " + months[d.getMonth()] + " " + d.getFullYear();
    }

    return '-'
};



class ApprovalView extends Component {

    source
    indexBloc = new IndexBloc()
    timer

    constructor(props) {
        super(props)
        this.state = {
            detail: null,
            typeOption: [],
            signatoriesOption: [],
            statusApproval: 0,
            typeFilter: {
                filter_value: "",
                page_number: 1,
                page_size: 50,
                sort_order: {
                    column: 'paid_leave_type_id',
                    order: 'asc' 
                }
            },
            signatoriesFilter: {
                filter_value: "",
                page_number: 1,
                page_size: 50,
                sort_order: {
                    column: 'signatories_official_id',
                    order: 'asc' 
                }
            } 
        }
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
              paid_leave_uuid: this.props.uuid,
              is_atasan: 1,
              ...values
            },
            confirm: true
        })
    }

    submitData = async () => {
        await this.indexBloc.fetchApproval(this.state.dataForm)
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }



    loadSignatoriesList = async () => {
        let offset = (this.state.signatoriesFilter.page_number-1)*this.state.signatoriesFilter.page_size
        const query = {
            search: this.state.signatoriesFilter.filter_value,
            limit: this.state.signatoriesFilter.page_size,
            offset: offset,
            order: this.state.signatoriesFilter.sort_order.column,
            sort: this.state.signatoriesFilter.sort_order.order,
            status: 1
        }
        await this.indexBloc.fetchSignatoriesList(query, this.source.token)
    }

    loadTypeList = async () => {
        let offset = (this.state.typeFilter.page_number-1)*this.state.typeFilter.page_size
        const query = {
            search: this.state.typeFilter.filter_value,
            limit: this.state.typeFilter.page_size,
            offset: offset,
            order: this.state.typeFilter.sort_order.column,
            sort: this.state.typeFilter.sort_order.order,
            status: 1
        }
        await this.indexBloc.fetchTypeList(query, this.source.token)
    }

    loadDetail = async () => {
        const query = { 
            uuid: this.props.uuid
        }
        await this.indexBloc.fetchDetail(query, this.source.token)

    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadTypeList()
        this.loadSignatoriesList()
        this.loadDetail()
    }

    handleSelectInputChange = value => {
        clearTimeout(this.timer)

        this.state.signatoriesFilter.filter_value = value

        this.timer = setTimeout(() => this.loadSignatoriesList(), 800);
    }

    componentDidMount = () => {
        this.setTokenAPI()

        this.indexBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ detail: result.data.response })
                    if (result.data.response?.paid_leave_approval_status > 0) {
                        this.setState({redirect : true})
                    }
                    console.log(result.data.response);
                    console.log('ghany');
                    break;
                default:
                    break;
            }
        })

        this.indexBloc.typeChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ typeOption: result.data.response.result })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.indexBloc.signatoriesChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ signatoriesOption: result.data.response })
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.indexBloc.approvalChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

    }

    componentWillUnmount = () => {
        this.indexBloc.detailChannel?.unsubscribe()
        this.indexBloc.typeChannel?.unsubscribe()
        this.indexBloc.signatoriesChannel?.unsubscribe()
        this.indexBloc.approvalChannel?.unsubscribe()
    }
    
    render() {
        const { detail } = this.state
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col md="12">
                            <Card>
                                <CardBody>
                                    <div className="float-end">
                                        <Link to={`/izinpegawai/cuti.html`}>
                                            <Button outline color="primary" ><i className="uil uil-backward"></i> Kembali</Button>
                                        </Link>
                                    </div>
                                    <CardTitle>Approval Pengajuan Cuti</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Jenis Cuti <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="4">
                                                { this.state.detail ? 
                                                    <Label className="col-form-label">
                                                        {this.state.detail?.paid_leave_type_full_name}
                                                    </Label>
                                                    :
                                                    <Shimmer>
                                                        <div style={{ width: "480px", height: "16px", alignSelf: "center", borderRadius: "8px", 
                                                                    marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5' }} />
                                                    </Shimmer>
                                                }
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal Mulai Cuti <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="4">
                                                { detail ? 
                                                    <Label className="col-form-label">
                                                        {reformatDate(detail?.paid_leave_start_date, true)}
                                                    </Label>
                                                    :
                                                    <Shimmer>
                                                        <div style={{ width: "480px", height: "16px", alignSelf: "center", borderRadius: "8px", 
                                                                    marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5' }} />
                                                    </Shimmer>
                                                }
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal Selesai Cuti <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="4">
                                                { detail ? 
                                                    <Label className="col-form-label">
                                                        {reformatDate(detail?.paid_leave_end_date, true)}
                                                    </Label>
                                                    :
                                                    <Shimmer>
                                                        <div style={{ width: "480px", height: "16px", alignSelf: "center", borderRadius: "8px", 
                                                                    marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5' }} />
                                                    </Shimmer>
                                                }
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Alasan Cuti <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="4">
                                                { detail ? 
                                                    <Label className="col-form-label">
                                                        {detail?.paid_leave_reason}
                                                    </Label>
                                                    :
                                                    <Shimmer>
                                                        <div style={{ width: "480px", height: "16px", alignSelf: "center", borderRadius: "8px", 
                                                                    marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5' }} />
                                                    </Shimmer>
                                                }
                                            </Col>
                                        </Row>


                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Alamat Selama Menjalankan Cuti
                                            </Label>
                                            <Col md="4">
                                                { detail ? 
                                                    <Label className="col-form-label">
                                                        {detail?.paid_leave_address}
                                                    </Label>
                                                    :
                                                    <Shimmer>
                                                        <div style={{ width: "480px", height: "16px", alignSelf: "center", borderRadius: "8px", 
                                                                    marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5' }} />
                                                    </Shimmer>
                                                }
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                No Telepon Selama Cuti
                                            </Label>
                                            <Col md="4">
                                                { detail ? 
                                                    <Label className="col-form-label">
                                                        {detail?.paid_leave_phone}
                                                    </Label>
                                                    :
                                                    <Shimmer>
                                                        <div style={{ width: "480px", height: "16px", alignSelf: "center", borderRadius: "8px", 
                                                                    marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5' }} />
                                                    </Shimmer>
                                                }
                                            </Col>
                                        </Row>

                                        <Row className="mb-2">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                File Pendukung
                                            </Label>
                                            <Label
                                                className="col-md-5 col-form-label"
                                            >
                                                { detail ? 
                                                    <Preview value={detail?.document} />
                                                    :
                                                    <Shimmer>
                                                        <div style={{ width: "480px", height: "16px", alignSelf: "center", borderRadius: "8px", 
                                                                    marginTop: 'calc(0.47rem + 1px)', marginBottom: 'calc(0.47rem + 1px)', fontSize: 'inherit', lineHeight: '1.5' }} />
                                                    </Shimmer>
                                                }
                                            </Label>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                className="col-md-2 col-form-label"
                                            >
                                                Status Approval <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="4">
                                                <Select
                                                    name="paid_leave_approval_status"
                                                    type="text"
                                                    options={[
                                                        {value: 1, label: 'Disetujui'},
                                                        {value: 2, label: 'Ditolak'}
                                                    ]}
                                                    onChange={opt => this.setState({ statusApproval: opt.value })}
                                                    defaultValue={this.state.statusApproval}
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        { this.state.statusApproval != 1  && 
                                            <Row className="mb-3">
                                                <Label
                                                    className="col-md-2 col-form-label"
                                                >
                                                    Catatan
                                                </Label>
                                                <Col md="4">
                                                    <AvField
                                                        name="paid_leave_note"
                                                        placeholder="Catatan"
                                                        errorMessage="Masukkan Catatan"
                                                        type="textarea"
                                                        className="form-control"
                                                    />
                                                </Col>
                                            </Row>
                                        }
                                        <Row className="mb-3">
                                            <Col md="2"></Col>
                                            <Col md="9">
                                                <Link to={`/izinpegawai/cuti.html`}>
                                                    <Button color="danger" type="button"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>


                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin data tersebut sudah benar?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to={'/izinpegawai/cuti.html'} />
                : null }

            </Fragment>
        )
    }

}

export default withRouter(ApprovalView)